import React, { Component } from "react";
import AboutUsCategories from '../api/about-us-categories';
import { getStaticText } from '../../../lables/lablesService';
import Spinner from '../../../components/spinner-component/Spinner';
import ImageInput from '../../../components/image-input-component/imageInput';
import HtmlInput from '../../../components/html-input-component/htmlInput';
import {PaginationButtons} from '../../../components/pagination-component/pagination';
import {SortableButton} from '../../../components/sortable-button-component/sortableButton';
import Popup from "reactjs-popup";

import 'reactjs-popup/dist/index.css';
import '../../../scss/os-global.scss';


class CategoriesPage extends Component {

    constructor(props) {
        super(props);

        this.types = [];
        this.page = 1;
        this.per_page = 10;
        this.all_pages = 0;
        this.order = {'position' : "ASC"};

        this.save_type_process = false;
        this.type_info = {};
        this.empty_type_info = {
            'id' : 0,
            'image' : '',
            'image_name' : '',
            'name' : '',
            'description' : '',
            'active' : 1,
            'position' : 99999
        };

        this.state = {
            'show_popup' : false,
            'has_data' : false,
            'increment' : 0
        };
    }


    changeTypeImage ( image_name, image ) {
        this.type_info.image_name = image_name;
        this.type_info.image = image;
        this.setState({
            'increment' : this.state.increment + 1
        });
    }


    changeTypeInfo ( prop_name, prop_value ) {
        let value = null;
        switch (prop_name) {
            case 'description':
                    value = prop_value;
                break;

            case 'active':
                    value = prop_value.target.checked ? 1 : 0;
                break;

            default:
                    value = prop_value.target.value
                break;
        }
        this.type_info[prop_name] = value;
    }


    async saveType () {
        if ( this.save_type_process )
            return false;

        const formData = new FormData();

        if ( this.type_info.id > 0 )
            formData.append( 'id', this.type_info.id );

        if ( typeof(this.type_info.image) === 'object' )
            formData.append( 'image', this.type_info.image );

        formData.append( 'name', this.type_info.name );
        formData.append( 'description', this.type_info.description );
        formData.append( 'position', this.type_info.position );
        formData.append( 'active', this.type_info.active );

        let result = null;
        if ( this.type_info.id === 0 )
            result = await AboutUsCategories.add( formData );
        else
            result = await AboutUsCategories.update( formData );
    
        if ( !result ) {
            window.alert( getStaticText('save_error') );
        } else {
            window.alert( getStaticText('save_success') );
            this.popupToggle();
            this.getTypesList();
        }
    }


    openAddNewTypeForm () {
        Object.assign(
            this.type_info,
            this.empty_type_info
        );
        this.popupToggle();
    }


    openEditTypeForm ( type_key = 0 ) {
        if ( typeof(this.types[type_key]) === 'undefined' )
            return false;
        Object.assign(
            this.type_info,
            this.types[type_key],
            {
                'image' : AboutUsCategories.getImageUrl(this.types[type_key].image)
            }
        );
        this.popupToggle();
    }

    async deleteCategory ( type_key = 0 ) {
        if ( typeof(this.types[type_key]) === 'undefined' )
            return false;
        
        if ( !window.confirm(getStaticText('remove_confirm_text')) )
            return false;

        let result = await AboutUsCategories.remove( this.types[type_key].id );
        if ( !result ) {
            window.alert( getStaticText('remove_error') );
        } else {
            window.alert( getStaticText('remove_success') );
            this.page = 1;
            this.getTypesList();
        }
    }

    popupToggle () {
        this.setState({
            'show_popup' : !this.state.show_popup
        });
    }


    async changePage (page_number = 1) {
        this.page = page_number;
        await this.getTypesList();
    }


    async changeOrder (new_order = {}) {
        this.order = new_order;
        await this.getTypesList();
    }


    async getTypesList () {
        this.setState({
            'has_data' : false
        });

        let list_response = await AboutUsCategories.list({
                                                        'page' : this.page,
                                                        'per_page' : this.per_page,
                                                        'order' : this.order
                                                    });
        if ( typeof(list_response.rows) !== 'undefined' ) {
            this.types = list_response.rows;
            this.all_pages = list_response.all_pages;
        }
        
        this.setState({
            'has_data' : true
        });
    }


    async componentDidMount () {
        await this.getTypesList();
    }


    render () {
        let content = null;
        if ( !this.state.has_data ) {
            content = (<div className="col-lg-12 text-center">{<Spinner />}</div>);
        } else {
            let list_of_categories = [];
            if ( !this.types.length ) {
                list_of_categories.push((<tr key="auc_empty_row">
                    <td 
                        colSpan="5" 
                        className="os-text-center"
                    >
                        {getStaticText('auc_table_empty_list_message')}
                    </td>
                </tr>));
            } else {
                for ( let key in this.types ) {
                    list_of_categories.push((<tr key={"auc_list_" + this.types[key].id}>
                        <td>
                            {this.types[key].id}
                        </td>
                        <td>
                            {this.types[key].name}
                        </td>
                        <td>
                            {this.types[key].active ? getStaticText('auc_table_body_active_yes_label') : getStaticText('auc_table_body_active_not_label')}
                        </td>
                        <td>
                            {this.types[key].position}
                        </td>
                        <td className="os-text-right">
                            <button 
                                className="btn btn-sm btn-info text-white os-mr-1"
                                title={getStaticText('auc_edit_button_title')}
                                onClick={this.openEditTypeForm.bind(this, key)}
                            >
                                <span className="fa fa-edit"></span>
                            </button>
                            <button 
                                className="btn btn-sm btn-danger text-white"
                                title={getStaticText('auc_delete_button_title')}
                                onClick={this.deleteCategory.bind(this, key)}
                            >
                                <span className="fa fa-trash"></span>
                            </button>
                        </td>
                    </tr>));
                }
            }


            content = (<>
                <div className="col-lg-12 text-end">
                    <button 
                        onClick={this.openAddNewTypeForm.bind(this)}
                        className="btn btn-success text-white"
                    >
                        {getStaticText('auc_add_new_button_label')}
                    </button>
                </div>

                <div className="col-lg-12 pt-3">
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr className="table-warning">
                                    <th>
                                        <SortableButton 
                                            column="id"
                                            currentSortable={this.order}
                                            multiSortable={false}
                                            callbackFunction={this.changeOrder.bind(this)}
                                        />
                                        {getStaticText('auc_table_head_id_label')}
                                    </th>
                                    <th>
                                        <SortableButton 
                                            column="name"
                                            currentSortable={this.order}
                                            multiSortable={false}
                                            callbackFunction={this.changeOrder.bind(this)}
                                        />
                                        {getStaticText('auc_table_head_name_label')}
                                    </th>
                                    <th>
                                        <SortableButton 
                                            column="active"
                                            currentSortable={this.order}
                                            multiSortable={false}
                                            callbackFunction={this.changeOrder.bind(this)}
                                        />
                                        {getStaticText('auc_table_head_active_label')}
                                    </th>
                                    <th>
                                        <SortableButton 
                                            column="position"
                                            currentSortable={this.order}
                                            multiSortable={false}
                                            callbackFunction={this.changeOrder.bind(this)}
                                        />
                                        {getStaticText('auc_table_head_position_label')}
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {list_of_categories}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="col-lg-12 pt-3 os-text-center">
                    <PaginationButtons 
                        activePage={this.page} 
                        allPages={this.all_pages}
                        callbackFunction={this.changePage.bind(this)}
                    />
                </div>

                <Popup
                    open={this.state.show_popup}
                    closeOnDocumentClick={false}
                    closeOnEscape={false}
                    className="os-popup"
                >
                    <>
                        <div className="os-popup-header">
                            <span className="op-popup-title">
                                {this.type_info.id ? getStaticText('auc_edit_popup_title') : getStaticText('auc_add_new_popup_title')}
                            </span>
                            <button
                                onClick={this.popupToggle.bind(this)}
                                className="os-popup-close-button"
                            >
                                <i className="fa fa-times" />
                            </button>
                        </div>

                        <div className="os-popup-body">
                            <ImageInput 
                                label={getStaticText('auc_form_image_input_label')}
                                fileImage={this.type_info.image}
                                fileName={this.type_info.image_name}
                                handleFile={this.changeTypeImage.bind(this)}
                            />

                            <div className="form-group">
                                <label
                                    htmlFor="aucNameInput"
                                >
                                    {getStaticText('auc_form_name_input_label')}
                                </label>
                                <input 
                                    id="aucNameInput"
                                    className="form-control"
                                    defaultValue={this.type_info.name}
                                    onChange={this.changeTypeInfo.bind(this, 'name')}
                                />
                            </div>

                            <HtmlInput 
                                label={getStaticText('auc_form_description_input_label')}
                                content={this.type_info.description}
                                inputName="description"
                                onChangeContent={this.changeTypeInfo.bind(this)}
                            />

                            <div className="form-group">
                                <label
                                    htmlFor="aucPositionInput"
                                >
                                    {getStaticText('auc_form_position_input_label')}
                                </label>
                                <input 
                                    id="aucPositionInput"
                                    className="form-control"
                                    defaultValue={this.type_info.position}
                                    onChange={this.changeTypeInfo.bind(this, 'position')}
                                />
                            </div>

                            <div className="form-group">
                                <label>
                                    <input 
                                        type="checkbox"
                                        defaultChecked={this.type_info.active}
                                        onChange={this.changeTypeInfo.bind(this, 'active')}
                                    /> {getStaticText('auc_form_active_input_label')}
                                </label>
                            </div>

                            <div className="form-group os-text-right">
                                <button
                                    className="btn btn-success"
                                    onClick={this.saveType.bind(this)}
                                >
                                    {this.type_info.id ? getStaticText('auc_form_update_button_label') : getStaticText('auc_form_add_button_label')}
                                </button>
                            </div>
                        </div>
                    </>
                </Popup>
            </>);
        }
        return (<div className="row">
                    <div className="col-lg-12">
                        <h2>{getStaticText('auc_section_title')}</h2>
                    </div>
                    {content}
                </div>);
    }

}


export default CategoriesPage